// extracted by mini-css-extract-plugin
export default {"actions":"Dialog_actions__CjJxa"};